import type { Feature, Geometry, Position } from "geojson"
import { BoundingBox } from "../types"
import { fetchPerimeters } from "./useFirePerimetersLayer"

function flattenPositions(geometry: Geometry): Position[] {
    switch (geometry.type) {
        case "Point":
            return [geometry.coordinates]
        case "MultiPoint":
        case "LineString":
            return geometry.coordinates
        case "MultiLineString":
        case "Polygon":
            return geometry.coordinates.flat()
        case "MultiPolygon":
            return geometry.coordinates.flat(2)
        case "GeometryCollection":
            return geometry.geometries.flatMap(flattenPositions)
        default:
            return []
    }
}

function intersectsRegion(feature: Feature, bbox: BoundingBox): boolean {
    if (!feature.geometry) return false
    const positions = flattenPositions(feature.geometry)
    return positions.some(
        ([lon, lat]) =>
            lon >= bbox.west && lon <= bbox.east && lat >= bbox.south && lat <= bbox.north
    )
}

// No polygon clipping — just keeps whole perimeters that overlap the print region at all,
// same as how the live map naturally shows shapes crossing the viewport edge unclipped.
export async function getWildfirePerimetersGeoJsonForRegion(bbox: BoundingBox) {
    const features = await fetchPerimeters()

    return {
        type: "FeatureCollection" as const,
        features: features.filter((feature) => intersectsRegion(feature, bbox)),
    }
}
